import { transformTableQueryForKy } from "../../helpers/tableHelpers";
import { InterventionTableQuery } from "../../pages/interventions/models";
import { privateGet } from "../clients/createPrivateClient";
import { TableResultCPIntervention } from "../models/unified";

export default {
  getInterventions: async (query: InterventionTableQuery) => {
    const result = await privateGet<TableResultCPIntervention>(
      "customerPortal/intervention/v2",
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
};
